import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, {useEffect, useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import { ContentsSection } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from 'swiper/modules';
import {CustomPopup, LoadingBox, MainPopup} from "component/basic/popup";
import {BtnBox, BtnItem} from "component/basic/btns";
import {
    MainCsItemBox,
    MainDataArea,
    MainDataSection,
    MainReviewSlideBox,
    MainSearchHistory, MainSliderBanner, MainSliderMobileBanner
} from "component/main/items";
import { CustomSelect, InputItemBox } from "component/basic/formItems";
import { datePramaSet, getParam, setDateTime } from "js/function";
import {CarSlideBox} from "component/product/car";
import { DateSelectPopup, InsurancePopup } from "pages/popup/Popup";


const Main = (props) => {
    const navigate = useNavigate();
    const termsId = getParam("terms");

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);
    const [dateSelectPopupData,setDateSelectPopupData] =  useState(null);
	const [insurancePopupData,setInsurancePopupData] =  useState(null);
	const [alertPopupData,setAlertPopupData] =  useState(null);

    const [btnChk,setBtnChk] =  useState(false);
    const [popupData, setPopupData] =  useState(null);
    const [imagePopupData, setImagePopupData] =  useState(null);
    const [isFirst,setIsFirst] =  useState(true);

    const [submitChk,setSubmitChk] =  useState(true);
    const [searchHistoryUpdate,setSearchHistoryUpdate] =  useState(1);

    const [reviewPage,setReviewPage] =  useState(1);

    const [filter,setFilter] =  useState({
        addr:"제주국제공항",
        startDtm:null,
        endDtm:null,
        birth:null,
        career:2,
        carCategory:[],
        insuranceId:null,
        insuranceName:null,
        search:null
    });
    
    const mainApi = useGet({
        url:filter?.startDtm && filter?.endDtm ? `/main?start_date=${filter?.startDtm ? datePramaSet(filter?.startDtm) : ""}&end_date=${filter?.endDtm ? datePramaSet(filter?.endDtm) : ""}&career=${filter?.career||""}` : null,
        loginType:"login"
    });
    const mainApiData = mainApi?.data;
    const event_cars = mainApiData?.event_cars;
    const popular_cars = mainApiData?.popular_cars;

    const mainContentsApi = useGet({
        url: `/main/contents`,
        loginType:"login"
    });
    const mainContentsApiData = mainContentsApi?.data;

    const mainReviewsApi = useGet({
        url: `/main/review?page=${reviewPage}`,
        loginType:"login"
    });
    const mainReviewApiData = mainReviewsApi?.data?.reviews;

    const events = mainContentsApiData?.events;
    const popups = mainContentsApiData?.popups;
    const banner = mainContentsApiData?.banner;
    const faqs = mainContentsApiData?.faqs;
    const notices = mainContentsApiData?.notices;

    const searchHistoryApi = useGet({
        url:`/search/history?type=main&update=${searchHistoryUpdate}`,
        loginType:"login"
    });
    const searchHistoryData = searchHistoryApi?.data?.search_histories;
    
	const insuranceApi = useGet({
        url:`/insurance`,
        loginType:"login"
    });
    const insuranceData = insuranceApi?.data?.insurances;

    const filterTypeDataApi = useGet({
        url:`/data/type?type=차종`,
        loginType:"login"
    });
    const filterTypeData = filterTypeDataApi?.data?.datas;

    const pageDataApi = useGet({
        url: localStorage.getItem("token") ? `/mypage/account` : "",
        loginType:"login"
    });
    const pageData = pageDataApi?.data?.user_info;
    
    useEffect(() => {
        if (popups) {
            setImagePopupData({
                images: popups,
                closeType:true,
            });
        }
    }, [popups]);

    useEffect(() => {
        if (pageData && (!filter.birth || filter.birth === "")) {
            filterDataCh("birth", pageData?.birth)
        }
    }, [pageData]);

    function filterDataCh(key,val){
        let oldData = {...filter};
        oldData[key] = val;
        setFilter(oldData);
    }

    function dateSelectPopupOpen(){
		setDateSelectPopupData({
			addClass:"rentCalendar",
            contentsAddClass:"scrollView",
			title:"대여/반납 일시 선택",
			closeType:true,
			closeFunc:(e) => {setDateSelectPopupData(null)}
		});
  	}

    function insurancePopupOpen(){
      setInsurancePopupData({
          addClass:null,
          title:"자차보험 선택",
          closeType:true,
          closeFunc:(e) => {setInsurancePopupData(null)}
      });
  	}

    useEffect(() => {
        setLoadingBoxOpen(true);

        if(termsId){
            if(termsId === "service"){
                window.termsPopupOpen("service","이용약관")
            }else if(termsId === "privacy"){
                window.termsPopupOpen("privacy","개인정보처리방침")
            }else if(termsId === "trouble"){
                window.termsPopupOpen("trouble","소비자 분쟁해결 기준")
            }
        }

        if(sessionStorage.getItem("joinSnsOpen")){
            window.joinPopupOpen("sns");
            sessionStorage.removeItem("joinSnsOpen");
        }

        let oldData = {...filter};
        let nowDate = new Date();

        nowDate.setDate(nowDate.getDate() + 7);
        oldData.startDtm = `${setDateTime(nowDate,"yymmdd","hymd")} 10:00`;

        nowDate.setDate(nowDate.getDate() + 1);
        oldData.endDtm = `${setDateTime(nowDate,"yymmdd","hymd")} 10:00`;

        setFilter(oldData);
    }, []);

    useEffect(() => {
        if(mainApiData){
            setLoadingBoxOpen(false);

            if (isFirst) {
                setPopupData({
                    imageUrl: "/assets/images/popupImg.png",
                    link: "https://amanorent.co.kr/mypage/coupon",
                    closeType:true,
                });
                setIsFirst(false)
            }
        }

        setTimeout(() => {
            setLoadingBoxOpen(false);
        }, 2000);
    }, [mainApi]);

    function saveHistory(data){
        if(submitChk && localStorage.getItem("token")) {
            setSubmitChk(false);

            let formData = new FormData();
            formData.append("start_date", data?.startDtm);
            formData.append("end_date", data?.endDtm);
            formData.append("insurance_id", data?.insuranceId);
            formData.append("insurance", data?.insuranceName);
            formData.append("type", "main");

            fatchSet.FatchApi({
                type:"POST",
                loginType: "login",
                formDataItem: formData,
                url: `/search/history/register`,
                success: (apiData) => {
                    setSubmitChk(true);
                },
                err: (apiData) => {
                    setSubmitChk(true);
                }
            })
        }
    }

    function historyDel(id){
        if(submitChk){
            setSubmitChk(false);

            fatchSet.FatchApi({
                type:"DELETE",
                loginType: "login",
                url: `/search/history/delete?history_id=${id}`,
                success: (apiData) => {
                    setSubmitChk(true);
                    setSearchHistoryUpdate(searchHistoryUpdate + 1);
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                }
            })
        }
    }

    return <>
        <ContentsSection
            header={true}
            footer={true}
            addClass={null}
        >
            <Header
                addClass=""
                logo={true}
                mMenu={true}
                pageBack={false}
                func={()=>{}}
                headTitle={null}
                rightBtnsArr={null}
                pageClose={false}
                closeFunc={()=>{}}
            />

            <MainSliderMobileBanner addClass="mItemTa" data={banner}>
                <MainDataSection addClass="mainTopBanner">
                    <MainDataArea addClass="mainArea mainTopBannerArea">
                        <MainSliderBanner type="pc" addClass="pcItemTa" data={banner}/>
                        <div className="mainFilterBox main">
                            <h1 className="mainFilter_title">차량 조회하기</h1>
                            <div className="mainFilter_inputBox">
                                <InputItemBox
                                    inputType={null}
                                    addClass=""
                                    inputName="<img src='/assets/images/icon/main_filter_icon_0.svg' alt=''/> 위치"
                                    placeholder="위치 선택"
                                    value={filter?.addr}
                                    max={null}
                                    regexp={null}
                                    errMsg={null}
                                    readOnly={true}
                                    func={(value)=>{}}
                                />
                                <InputItemBox
                                    inputType={null}
                                    addClass="readOnlyNotColor"
                                    inputName="<img src='/assets/images/icon/main_filter_icon_1.svg' alt=''/> 대여/반납 일시"
                                    placeholder="대여/반납 일시 선택"
                                    value={filter?.startDtm && filter?.endDtm ? `${setDateTime(filter?.startDtm,"daymmddhh",null)} ~ ${setDateTime(filter?.endDtm,"daymmddhh",null)}` : null}
                                    max={null}
                                    regexp={null}
                                    errMsg={null}
                                    readOnly={true}
                                    func={(value)=>{}}
                                    clickInput={()=>{dateSelectPopupOpen()}}
                                />
                                <CustomSelect
                                    multiple={true}
                                    basicSelText={"전체"}
                                    addClass="absoluteSel"
                                    inputName="<img src='/assets/images/icon/main_filter_icon_4.svg' alt=''/> 대여 희망 차종"
                                    placeholder="대여 희망 차종 선택"
                                    value={filter?.carCategory}
                                    func={(arr) => {
                                        filterDataCh("carCategory",arr)
                                    }}
                                    disabled={false}
                                    valKey="id"
                                    nameKey="name"
                                    options={filterTypeData ? [
                                        {id:"all",name:"전체"},
                                        ...filterTypeData
                                    ] : [{id:"all",name:"전체"}]}
                                />
                            </div>
                            <BtnItem
                                addClass={`flex gradient ${btnChk ? "disableBtn" : ""}`}
                                contents="원하는 차량 검색하기<img src='/assets/images/basic/filter_btn_move.svg' alt=''/>"
                                func={() => {insurancePopupOpen()}}
                            />
                        </div>
                    </MainDataArea>
                </MainDataSection>
            </MainSliderMobileBanner>
            {searchHistoryData?.length > 0 && <MainDataSection addClass="mainSlideSection">
                <MainDataArea>
                    <MainSearchHistory
                        title="최근 찾아본 일정"
                        data={searchHistoryData}
                        deleteFunc={(itemId) => { historyDel(itemId) }}
                    />
                </MainDataArea>
            </MainDataSection>}
            <MainDataSection addClass="mainSlideSection">
                <MainDataArea>
                    <CarSlideBox
                        data={event_cars}
                        title="최저가 차량 리스트"
                        subTitle="특가 할인 이벤트가 진행중인 차량"
                        notListText="최저가 차량 리스트가 없습니다."
                        func={(name, insuranceId)=>{
                            let oldData = {...filter};
                            oldData.search = name;
                            oldData.insuranceId = insuranceId ? insuranceId : "";
                            setFilter(oldData);

                            setTimeout(() => {
                                navigate("/rent/list",{state: {filterData:oldData}});
                            }, 100);
                        }}
                    />
                </MainDataArea>
            </MainDataSection>
            <div className="mainSubBanner">
                <Swiper
                    spaceBetween={0}
                    slidesPerView={1}
                    // autoHeight={true}
                    loop={true}
                    pagination={true}
                    // modules={[Pagination]}
                    autoplay={{delay: 7000, disableOnInteraction: false}}
                    modules={[Pagination,Autoplay]}
                >
                    {events && events?.map((item, i) => <SwiperSlide key={i}>
                            <>
                                {item.link ?
                                    <>
                                    <a href={item.link} target="_blank" aria-label={item?.image_alt ?? ("이벤트 배너-" + (i+1))} style={{"backgroundImage":`url('${item.image_url_pc ? item.image_url_pc : item.image_url}')`}} className="backgroundImg mainSubBannerImg pcItem"/>
                                    <a href={item.link} target="_blank" aria-label={item?.image_alt ?? ("이벤트 배너-" + (i+1))} style={{"backgroundImage":`url('${item.image_url}')`}} className="backgroundImg mainSubBannerImg mItem"/>
                                    </>
                                    :
                                    <>
                                    <Link to={`/event/detail/${item.id}`} aria-label={item?.image_alt ?? ("이벤트 배너-" + (i+1))} style={{"backgroundImage":`url('${item.image_url_pc ? item.image_url_pc : item.image_url}')`}} className="backgroundImg mainSubBannerImg pcItem"/>
                                    <Link to={`/event/detail/${item.id}`} aria-label={item?.image_alt ?? ("이벤트 배너-" + (i+1))} style={{"backgroundImage":`url('${item.image_url}')`}} className="backgroundImg mainSubBannerImg mItem"/>
                                    </>
                                }
                            </>
                        </SwiperSlide>)}
                </Swiper>
            </div>
            {/*<MainDataSection addClass="mainSlideSection">
                <MainDataArea>
                    <CarSlideBox
                        type="popularCar"
                        data={popular_cars}
                        title="인기 차량 리스트"
                        subTitle="최근 1개월 간 예약이 가장 많은 차량"
                        notListText="인기 차량 리스트가 없습니다."
                        func={(name, insuranceId)=>{
                            let oldData = {...filter};
                            oldData.search = name;
                            oldData.insuranceId = insuranceId ? insuranceId : "";
                            setFilter(oldData);

                            setTimeout(() => {
                                navigate("/rent/list",{state: {filterData:oldData}});
                            }, 100);
                        }}
                    />
                </MainDataArea>
            </MainDataSection>*/}
            <MainDataSection addClass="mainSlideSection review">
                <MainDataArea>
                    <MainReviewSlideBox
                        type="review"
                        data={mainReviewApiData}
                        title="이용하신 분들의 솔직한 후기를 확인해보세요"
                        subTitle="차량 이용 후기"
                        notListText="차량 이용 후기가 없습니다."
                        pageFunc={(page) => setReviewPage(page)}
                        func={(name, insuranceId)=>{
                            let oldData = {...filter};
                            oldData.search = name;
                            oldData.insuranceId = insuranceId ? insuranceId : "";
                            setFilter(oldData);

                            setTimeout(() => {
                                navigate("/rent/list",{state: {filterData:oldData}});
                            }, 100);
                        }}
                    />
                </MainDataArea>
            </MainDataSection>
            <MainDataSection addClass="mainSlideSection">
                <MainDataArea>
                </MainDataArea>
            </MainDataSection>
            <MainDataSection addClass="mainCsSection">
                <MainDataArea addClass="mainCsArea">
                    <MainCsItemBox
                        type="faq"
                        title="자주 찾는 질문"
                        func={()=>{navigate("/faq")}}
                        data={faqs}
                    />
                    <MainCsItemBox
                        type="notice"
                        title="공지사항"
                        func={()=>{navigate("/notice")}}
                        data={notices}
                    />
                </MainDataArea>
            </MainDataSection>
        </ContentsSection>
        <DateSelectPopup
            popupData={dateSelectPopupData}
            btnType={true}
            subBtnText={"취소"}
            subBtnFunc={()=>{
                setDateSelectPopupData(null);
            }}
            btnText={"선택 완료"}
            btnFunc={(start,end)=>{
                let oldData = {...filter};
                oldData.startDtm = start;
                oldData.endDtm = end;
                setFilter(oldData);

                setDateSelectPopupData(null);
            }}
        />
        <InsurancePopup
            popupData={insurancePopupData}
            data={insuranceData}
            btnType={true}
            subBtnText={"취소"}
            subBtnFunc={()=>{
                setInsurancePopupData(null);
            }}
            btnText={"차량 검색"}
            btnFunc={(id)=>{
                let oldData = {...filter};
                oldData.insuranceId = id;
                oldData.insuranceName = insuranceData?.filter((el)=>el.id === oldData?.insuranceId)[0]?.name;
                setFilter(oldData);

                setInsurancePopupData(null);

                saveHistory(oldData)

                setTimeout(() => {
                    navigate("/rent/list",{state: {filterData:oldData}});
                }, 100);
            }}
        />
        <Footer/>
        <LoadingBox openType={loadingBoxOpen}/>

        <CustomPopup data={alertPopupData} toastType={true}>
            <BtnBox
                boxType="fixed"
                addClass=""
            >
                <BtnItem
                    addClass="subColor"
                    contents={"확인"}
                    disabled={false}
                    func={() => {
                        setAlertPopupData(null);
                    }}
                />
            </BtnBox>
        </CustomPopup>

        <MainPopup
            data={imagePopupData}
        />
    </>;
};

export default Main;

